var _rect, _path, _path2, _rect2, _path3, _path4, _rect3, _path5, _path6, _rect4, _path7, _rect5, _path8, _path9, _rect6, _path10, _path11, _rect7, _path12, _path13, _rect8, _path14, _rect9, _path15, _path16, _rect10, _path17, _path18, _rect11, _path19, _path20, _rect12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFigure3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 656,
    height: 40,
    viewBox: "0 0 656 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    fill: "white",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1067 26V24.668H21.5147V12.734H20.2007L16.6547 15.794L17.5367 16.856L19.9307 14.714C19.9127 14.84 19.9127 15.002 19.9127 15.164V24.668H16.9787V26H24.1067Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5289 14.2197C47.7893 13.9268 48.2114 13.9268 48.4717 14.2197L53.1384 19.4697C53.3987 19.7626 53.3987 20.2374 53.1384 20.5303L48.4717 25.7803C48.2114 26.0732 47.7893 26.0732 47.5289 25.7803C47.2686 25.4874 47.2686 25.0126 47.5289 24.7197L51.0575 20.75H43.3337C42.9655 20.75 42.667 20.4142 42.667 20C42.667 19.5858 42.9655 19.25 43.3337 19.25H51.0575L47.5289 15.2803C47.2686 14.9874 47.2686 14.5126 47.5289 14.2197Z",
    fill: "#2D3648"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 56.5,
    y: 0.5,
    width: 39,
    height: 39,
    fill: "white",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2727 20.456V19.25H76.7207V17.468H81.3647V11.528H79.9067V13.328H72.0587V11.528H70.6007V17.468H75.2447V19.25H68.6567V20.456H83.2727ZM79.9067 16.298H72.0587V14.462H79.9067V16.298ZM81.4907 21.932H70.4747V27.116H81.4907V21.932ZM80.0507 25.928H71.9147V23.12H80.0507V25.928Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103.529 14.2197C103.789 13.9268 104.211 13.9268 104.472 14.2197L109.138 19.4697C109.399 19.7626 109.399 20.2374 109.138 20.5303L104.472 25.7803C104.211 26.0732 103.789 26.0732 103.529 25.7803C103.269 25.4874 103.269 25.0126 103.529 24.7197L107.058 20.75H99.3337C98.9655 20.75 98.667 20.4142 98.667 20C98.667 19.5858 98.9655 19.25 99.3337 19.25H107.058L103.529 15.2803C103.269 14.9874 103.269 14.5126 103.529 14.2197Z",
    fill: "#2D3648"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 112.5,
    y: 0.5,
    width: 39,
    height: 39,
    fill: "white",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M136.449 26V24.542H131.247C130.797 24.542 130.257 24.614 129.753 24.758L133.443 21.104C134.937 19.61 136.197 18.242 136.197 16.28C136.197 13.94 134.451 12.572 132.201 12.572C129.951 12.572 128.205 13.886 127.863 16.316L129.483 16.586C129.483 15.074 130.599 13.994 132.111 13.994C133.479 13.994 134.487 14.732 134.541 16.316C134.541 17.864 133.533 18.998 132.147 20.474L127.593 24.848V26H136.449Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M159.529 14.2197C159.789 13.9268 160.211 13.9268 160.472 14.2197L165.138 19.4697C165.399 19.7626 165.399 20.2374 165.138 20.5303L160.472 25.7803C160.211 26.0732 159.789 26.0732 159.529 25.7803C159.269 25.4874 159.269 25.0126 159.529 24.7197L163.058 20.75H155.334C154.965 20.75 154.667 20.4142 154.667 20C154.667 19.5858 154.965 19.25 155.334 19.25H163.058L159.529 15.2803C159.269 14.9874 159.269 14.5126 159.529 14.2197Z",
    fill: "#2D3648"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 168.5,
    y: 0.5,
    width: 39,
    height: 39,
    fill: "white",
    stroke: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M215.529 14.2197C215.789 13.9268 216.211 13.9268 216.472 14.2197L221.138 19.4697C221.399 19.7626 221.399 20.2374 221.138 20.5303L216.472 25.7803C216.211 26.0732 215.789 26.0732 215.529 25.7803C215.269 25.4874 215.269 25.0126 215.529 24.7197L219.058 20.75H211.334C210.965 20.75 210.667 20.4142 210.667 20C210.667 19.5858 210.965 19.25 211.334 19.25H219.058L215.529 15.2803C215.269 14.9874 215.269 14.5126 215.529 14.2197Z",
    fill: "#2D3648"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 224.5,
    y: 0.5,
    width: 39,
    height: 39,
    fill: "white",
    stroke: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M239.917 16.352L241.555 16.622C241.555 15.146 242.653 14.03 244.165 14.03C245.551 14.03 246.523 14.768 246.523 16.28C246.523 17.648 245.695 18.602 243.373 18.656V19.844C246.199 19.844 246.793 20.888 246.793 22.31C246.793 23.48 245.875 24.812 243.985 24.812C242.617 24.812 241.807 24.11 241.249 22.958C241.105 22.616 241.015 22.346 240.979 22.148L239.503 22.76C240.133 24.704 241.159 26.234 244.003 26.234C246.469 26.234 248.467 24.686 248.467 22.274C248.467 20.618 247.567 19.52 245.839 19.088C247.279 18.602 248.161 17.738 248.161 16.01C248.161 13.994 246.541 12.59 244.255 12.59C242.005 12.59 240.259 13.958 239.917 16.352Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M271.529 14.2197C271.789 13.9268 272.211 13.9268 272.472 14.2197L277.138 19.4697C277.399 19.7626 277.399 20.2374 277.138 20.5303L272.472 25.7803C272.211 26.0732 271.789 26.0732 271.529 25.7803C271.269 25.4874 271.269 25.0126 271.529 24.7197L275.058 20.75H267.334C266.965 20.75 266.667 20.4142 266.667 20C266.667 19.5858 266.965 19.25 267.334 19.25H275.058L271.529 15.2803C271.269 14.9874 271.269 14.5126 271.529 14.2197Z",
    fill: "#2D3648"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 280.5,
    y: 0.5,
    width: 39,
    height: 39,
    fill: "white",
    stroke: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M296.815 18.962H299.407V17.738H296.815V11.186H295.339V27.332H296.815V18.962ZM292.639 12.914H285.259V14.138H291.181C290.839 18.026 288.697 21.014 284.503 23.12L285.313 24.272C290.533 21.68 292.639 17.504 292.639 12.914ZM308.244 17.054C311.79 17.054 313.914 16.082 313.914 14.264C313.914 12.446 311.79 11.456 308.244 11.456C304.698 11.456 302.574 12.446 302.574 14.264C302.574 16.082 304.698 17.054 308.244 17.054ZM308.244 12.572C310.926 12.572 312.402 13.184 312.402 14.264C312.402 15.344 310.926 15.956 308.244 15.956C305.562 15.956 304.086 15.344 304.086 14.264C304.086 13.184 305.562 12.572 308.244 12.572ZM315.552 19.34V18.152H300.936V19.34H315.552ZM314.166 26H304.194V24.362H313.68V20.726H302.7V21.842H312.222V23.282H302.754V27.152H314.166V26Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M327.529 14.2197C327.789 13.9268 328.211 13.9268 328.472 14.2197L333.138 19.4697C333.399 19.7626 333.399 20.2374 333.138 20.5303L328.472 25.7803C328.211 26.0732 327.789 26.0732 327.529 25.7803C327.269 25.4874 327.269 25.0126 327.529 24.7197L331.058 20.75H323.334C322.965 20.75 322.667 20.4142 322.667 20C322.667 19.5858 322.965 19.25 323.334 19.25H331.058L327.529 15.2803C327.269 14.9874 327.269 14.5126 327.529 14.2197Z",
    fill: "#2D3648"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 336.5,
    y: 0.5,
    width: 39,
    height: 39,
    fill: "white",
    stroke: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M361.079 22.49V21.194H359.081V12.662H357.533L351.035 21.266V22.49H357.623V26H359.081V22.49H361.079ZM357.623 15.686V21.194H352.835L357.695 14.57C357.641 14.948 357.623 15.38 357.623 15.686Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M383.529 14.2197C383.789 13.9268 384.211 13.9268 384.472 14.2197L389.138 19.4697C389.399 19.7626 389.399 20.2374 389.138 20.5303L384.472 25.7803C384.211 26.0732 383.789 26.0732 383.529 25.7803C383.269 25.4874 383.269 25.0126 383.529 24.7197L387.058 20.75H379.334C378.965 20.75 378.667 20.4142 378.667 20C378.667 19.5858 378.965 19.25 379.334 19.25H387.058L383.529 15.2803C383.269 14.9874 383.269 14.5126 383.529 14.2197Z",
    fill: "#2D3648"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 392.5,
    y: 0.5,
    width: 39,
    height: 39,
    fill: "white",
    stroke: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M439.529 14.2197C439.789 13.9268 440.211 13.9268 440.472 14.2197L445.138 19.4697C445.399 19.7626 445.399 20.2374 445.138 20.5303L440.472 25.7803C440.211 26.0732 439.789 26.0732 439.529 25.7803C439.269 25.4874 439.269 25.0126 439.529 24.7197L443.058 20.75H435.334C434.965 20.75 434.667 20.4142 434.667 20C434.667 19.5858 434.965 19.25 435.334 19.25H443.058L439.529 15.2803C439.269 14.9874 439.269 14.5126 439.529 14.2197Z",
    fill: "#2D3648"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 448.5,
    y: 0.5,
    width: 39,
    height: 39,
    fill: "white",
    stroke: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M466.077 17.72L466.671 14.264H471.837V12.752H465.519L464.439 18.998L465.501 19.304C466.275 19.034 466.959 18.872 467.661 18.872C469.551 18.872 470.667 19.88 470.667 21.608C470.667 23.552 469.353 24.686 467.535 24.686C466.455 24.686 465.411 24.2 464.619 23.534L463.737 24.74C464.547 25.514 465.879 26.162 467.463 26.162C470.145 26.162 472.251 24.326 472.251 21.518C472.251 19.214 470.757 17.486 467.967 17.486C467.319 17.486 466.689 17.558 466.077 17.72Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M495.529 14.2197C495.789 13.9268 496.211 13.9268 496.472 14.2197L501.138 19.4697C501.399 19.7626 501.399 20.2374 501.138 20.5303L496.472 25.7803C496.211 26.0732 495.789 26.0732 495.529 25.7803C495.269 25.4874 495.269 25.0126 495.529 24.7197L499.058 20.75H491.334C490.965 20.75 490.667 20.4142 490.667 20C490.667 19.5858 490.965 19.25 491.334 19.25H499.058L495.529 15.2803C495.269 14.9874 495.269 14.5126 495.529 14.2197Z",
    fill: "#2D3648"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 504.5,
    y: 0.5,
    width: 39,
    height: 39,
    fill: "white",
    stroke: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M531.273 20.456V19.25H524.721V17.468H529.365V11.528H527.907V13.328H520.059V11.528H518.601V17.468H523.245V19.25H516.657V20.456H531.273ZM527.907 16.298H520.059V14.462H527.907V16.298ZM529.491 21.932H518.475V27.116H529.491V21.932ZM528.051 25.928H519.915V23.12H528.051V25.928Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M551.529 14.2197C551.789 13.9268 552.211 13.9268 552.472 14.2197L557.138 19.4697C557.399 19.7626 557.399 20.2374 557.138 20.5303L552.472 25.7803C552.211 26.0732 551.789 26.0732 551.529 25.7803C551.269 25.4874 551.269 25.0126 551.529 24.7197L555.058 20.75H547.334C546.965 20.75 546.667 20.4142 546.667 20C546.667 19.5858 546.965 19.25 547.334 19.25H555.058L551.529 15.2803C551.269 14.9874 551.269 14.5126 551.529 14.2197Z",
    fill: "#2D3648"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 560.5,
    y: 0.5,
    width: 39,
    height: 39,
    fill: "white",
    stroke: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M578.977 17.72L582.955 12.734H580.885L577.213 17.684C576.061 19.196 575.575 20.528 575.575 21.698C575.575 24.434 577.321 26.234 580.003 26.234C582.703 26.234 584.575 24.326 584.575 21.878C584.575 19.34 582.775 17.9 580.615 17.9C579.733 17.9 578.995 18.152 578.347 18.584C578.473 18.44 578.671 18.152 578.977 17.72ZM579.967 24.848C578.167 24.848 577.177 23.696 577.177 21.968C577.177 20.474 578.311 19.178 580.075 19.178C581.713 19.178 582.919 20.258 582.919 22.004C582.919 23.642 581.713 24.848 579.967 24.848Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M607.529 14.2197C607.789 13.9268 608.211 13.9268 608.472 14.2197L613.138 19.4697C613.399 19.7626 613.399 20.2374 613.138 20.5303L608.472 25.7803C608.211 26.0732 607.789 26.0732 607.529 25.7803C607.269 25.4874 607.269 25.0126 607.529 24.7197L611.058 20.75H603.334C602.965 20.75 602.667 20.4142 602.667 20C602.667 19.5858 602.965 19.25 603.334 19.25H611.058L607.529 15.2803C607.269 14.9874 607.269 14.5126 607.529 14.2197Z",
    fill: "#2D3648"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 616.5,
    y: 0.5,
    width: 39,
    height: 39,
    fill: "white",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigure3);
export default __webpack_public_path__ + "static/media/figure3.905ed28d1f23e56fefa783a8b5a4fd8e.svg";
export { ForwardRef as ReactComponent };